import { defineComponent, defineAsyncComponent } from 'vue';

export default defineComponent({
	components: {
		ReviewsRating: defineAsyncComponent(() => import('./components/ReviewsRating/ReviewsRating.vue')),
		ReviewsGlimpse: defineAsyncComponent(
			() => import('@/presentation/components/WidgetReviewsGlimpse/WidgetReviewsGlimpse.vue')
		),
		PortalBadges: defineAsyncComponent(() => import('@/presentation/components/PortalBadges/PortalBadges.vue')),
		WidgetReviewsAll: defineAsyncComponent(
			() => import('@/presentation/components/WidgetReviewsAll/WidgetReviewsAll.vue')
		),
	},
	props: {
		reviewsWidget: String,
		reviewsReferrer: String,
		organisationId: String,
		isSingleBadge: Boolean,
		isSmall: Boolean,
		isOpen: Boolean,
	},
	setup: (props) => {
		return {
			reviewsWidget: props.reviewsWidget,
			reviewsReferrer: props.reviewsReferrer,
			organisationId: props.organisationId,
			isSingleBadge: props.isSingleBadge,
			isSmall: props.isSmall,
			isOpen: props.isOpen,
		};
	},
});
